import React from 'react';

import IconButton from '@mui/material/IconButton';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { useAppSelector } from 'hooks/redux';

type GuideButtonProps = {
  guideId: string | undefined;
};

/**
 * GuideButton renders a help icon button that integrates with the user guide system.
 * The button is only rendered when the userGuideEnabled feature flag is enabled and a guideId is provided.
 */
const GuideButton = ({ guideId }: GuideButtonProps) => {
  const isUserGuideEnabled = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'userGuideEnabled'));

  if (!isUserGuideEnabled || !guideId) {
    return null;
  }

  return (
    <IconButton aria-label='Guide' id={guideId} size='small' variant='tonal'>
      <HelpOutlineRoundedIcon />
    </IconButton>
  );
};

export default GuideButton;
